import React from "react";
import styled from "styled-components";

const achievementsData = [
    {
        id: 1,
        title: "Чемпіонат Світу серед юнаків до 21 року",
        description:
            "У 2017 року Україна отримала почесне право провести Чемпіонат Світу серед юнаків до 21 року (катерна версія) у місті Дніпро. Це позитивно відобразилося на іміджі країни в цілому, оскільки учасники з 22 країн світу та супроводжуючі їх вболівальники приїхали змагатися за почесні місця. Всі гості відзначили високий рівень проведення та організацію Чемпіонату. Український спортсмен, майстер спорту України міжнародного класу, Фільченко Данило, спортсмен національної збірної України виборов 1 місце у фігурному катанні на водних лижах та 1 місце багатоборств.",
        imageUrl: "water.png",
        alt: "Чемпіонат Світу серед юнаків до 21 року"
    },
    {
        id: 2,
        title: "Відкриття канатної дороги",
        description: "У 2013 році у місті Дніпро була відкрита кільцева канатна дорога для воднолижників та вейкбордистів, довжина якої становить понад 800 метрів. Це єдина канатна дорога світового рівня в Україні. Кататися на трасі можуть одночасно 12 людей.  «Спорудження, яке відкривається сьогодні – унікальне. Воно складається з двох компонентів: перший – це реверсна дорога, яка дозволяє навчити тих, хто не вміє кататися на лижах, другий – траса, яка відповідає всім нормативам для проведення змагань найвищого рівня», - сказав на відкритті міський голова Іван Куліченко. Відразу після урочистого відкриття діти у гідрокостюмах із задоволенням випробували нову суперсучасну воднолижну трасу. Виступ кожного юного спортсмена присутнім коментував Президент федерації воднолижного спорту і вейкбордингу України Олексій Мартинов, на чиї кошти і збудовано трасу. Мартинов поділився з усіма подальшими планами на розвиток та популяризацію воднолижного спорту. Він запевнив, що нова буксирувальна траса призначена не лише для спортсменів, сюди може прийти будь-який городянин чи гість міста. З того часу комплекс Sentosa став популярним місцем відпочинку біля води для мешканців міста Дніпро з травня по жовтень. Він знаходиться за адресою м. Дніпро, вул Набережна Перемоги 37 б. А на базі цього комплексу згодом було проведено Чемпіонат Європи з воднолижного спорту (кабельна версія) та навіть перший в Україні Чемпіонат Світу з воднолижного спорту (кабельна версія) у 2018 році, у якому приняло участь 80 спортсменів з 13 країн світу.",
        imageUrl: "water.png",
        alt: "Відкриття канатної дороги"
    },
    {
        id: 3,
        title: "Розвиток молодіжного спорту",
        description:
            "Федерація активно працює над розвитком молодіжного спорту, організовуючи тренування, табори та змагання для молодих талантів. Ми віримо, що інвестування в молодь - це інвестиція в майбутнє водних видів спорту в Україні.",
        imageUrl: "water.png",
        alt: "Розвиток молодіжного спорту"
    }
]

const Achievements = () => {
    return (
        <StyledAchievementsContainer>
            <StyledTitle>Наші досягнення</StyledTitle>
            <StyledDescription>
                Любов до водних видів спорту завжди була основою нашої Федерації, і ми пишаємося накопиченими досягненнями нашої спільноти воднолижників і вейкбордистів.
            </StyledDescription>
            <StyledAchievements>
                {achievementsData.map(({ id, title, description, imageUrl, alt }) => (
                    <AchievementCard key={id} title={title} description={description} imageUrl={imageUrl} alt={alt} />
                ))}
            </StyledAchievements>
        </StyledAchievementsContainer>
    );
};

const AchievementCard = ({ title, description, imageUrl, alt }) => (
    <StyledCard>
        <StyledImage src={imageUrl} alt={alt} loading="lazy" />
        <StyledCardTitle>{title}</StyledCardTitle>
        <StyledCardDescription>{description}</StyledCardDescription>
    </StyledCard>
);

const StyledAchievementsContainer = styled.section`
    padding-top: 110px;
  display: flex;
  flex-direction: column;
`;

const StyledTitle = styled.h1`
  color: #970711;
  text-align: center;
  margin-top: 10px;
  font: 400 30px Poppins, sans-serif;
`;

const StyledDescription = styled.p`
  color: #042259;
  text-align: center;
  margin-top: 40px;
  font: 400 20px Poppins, sans-serif;
  padding: 0 20px;
`;

const StyledAchievements = styled.div`
  display: flex;
  gap: 20px;
  flex-wrap: wrap;
  justify-content: center;
  margin-top: 40px;

  @media (max-width: 991px) {
    flex-direction: column;
    align-items: stretch;
    gap: 0;
  }
`;

const StyledCard = styled.div`
  flex: 1;
  max-width: 33%;
  display: flex;
  flex-direction: column;
  text-align: center;
  margin: 20px;

  @media (max-width: 991px) {
    max-width: 100%;
  }
`;

const StyledImage = styled.img`
  aspect-ratio: 1;
  width: 100%;
  object-fit: cover;
`;

const StyledCardTitle = styled.h2`
  margin-top: 20px;
  font: 600 20px Poppins, sans-serif;
    text-align: left;
    color: #042259;
`;

const StyledCardDescription = styled.p`
  margin-top: 10px;
  font: 400 15px Poppins, sans-serif;
    text-align: left;
    width: 100%;
`;

export default Achievements;